import { trackingEventDictionary } from "../../../../core/dictionary/track-events";
import { generateTrackingObject, trademoTrackingEvents } from "../../../../core/utility/trademo-tracking";

import securityDetails from "./../../../../assets/images/accounts/sec_tick.PNG";
export default function ProfileDetails(props) {
  return (
    <div>
      <h4 className="mx-4 my-3 main-profile-header">Security Details</h4>
      <div className="card mx-4">
        <div className="card-body">
          <div className="">
            <div className="row">
              <div className="col-4">
                <h3 className="card-title my-1">Password</h3>
                {/* <h4 className="label-block">Last Edited 10 Days Ago</h4> */}
              </div>
              <div className="col-4"></div>
              <div className="col-4"></div>
            </div>
            <div className="row">
              <div className="col-4"></div>
              <div style={{ textAlign: "center" }} className="col-4">
                <img src={securityDetails} style={{ margin: "0 auto" }} />
                <br />
              </div>
              <div className="col-4"></div>
            </div>
            <div className="row mt-3">
              <div className="col-4 "></div>
              <div style={{ textAlign: "center" }} className="col-4">
                <button
                  onClick={() => {
                    props.togglefunc1();
                    trademoTrackingEvents(trackingEventDictionary.headerUserProfileProfileDetailsSecurityChangePassword, generateTrackingObject());
                  }}
                  className="btn btn-primary btn-change-password"
                >
                  Change Password
                </button>
              </div>
              <div className="col-4"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
